import { Box, Container, Divider, Grid, IconButton, Stack, Typography } from "@mui/material"
import { FacebookOutlined } from "@mui/icons-material"
import { Link as RouterLink } from "react-router-dom"

import Logo from "../assets/Logo.png"
import { homeCopy } from "../content/homeCopy"
import { DRIVER_PORTAL_URL } from "../constants/links"
import { OFFICE_ADDRESS_SHORT } from "../constants/address"
import {
    EMAIL,
    EMAIL_HREF,
    FACEBOOK_URL,
    PHONE_DISPLAY,
    PHONE_HREF,
} from "../constants/contactInfo"
import { useEnquire } from "./EnquireModal"

const linkSx = {
    color: "rgba(255, 255, 255, 0.78)",
    textDecoration: "none",
    fontSize: "0.95rem",
    lineHeight: 1.6,
    transition: "color 0.15s ease",
    "&:hover": {
        color: "#00A3FF",
    },
}

const headingSx = {
    color: "#fff",
    fontWeight: 700,
    fontSize: "0.8rem",
    letterSpacing: "0.08em",
    textTransform: "uppercase",
    mb: 2,
}

const Footer = () => {
    const openEnquire = useEnquire()
    const year = new Date().getFullYear()

    return (
        <Box
            component="footer"
            sx={{
                background: "#000435",
                color: "#fff",
                pt: { xs: 6, md: 8 },
                pb: 0,
            }}
        >
            <Container maxWidth="lg">
                <Grid container spacing={{ xs: 4, md: 6 }}>
                    <Grid item xs={12} md={5}>
                        <Box
                            component="img"
                            src={Logo}
                            alt="Stargate Rentals"
                            sx={{ maxHeight: 44, mb: 2.5, display: "block" }}
                        />
                        <Typography
                            variant="body2"
                            sx={{
                                color: "rgba(255, 255, 255, 0.68)",
                                maxWidth: 320,
                                lineHeight: 1.7,
                            }}
                        >
                            {homeCopy.footer.tagline}
                        </Typography>
                    </Grid>

                    <Grid item xs={6} sm={4} md={2}>
                        <Typography sx={headingSx}>Explore</Typography>
                        <Stack spacing={1.25}>
                            <Typography component={RouterLink} to="/vehicles" sx={linkSx}>
                                Available vehicles
                            </Typography>
                            <Typography component={RouterLink} to="/faqs" sx={linkSx}>
                                FAQs
                            </Typography>
                            <Typography
                                component="button"
                                type="button"
                                onClick={() => openEnquire?.()}
                                sx={{
                                    ...linkSx,
                                    background: "none",
                                    border: 0,
                                    p: 0,
                                    cursor: "pointer",
                                    textAlign: "left",
                                    font: "inherit",
                                }}
                            >
                                Enquire now
                            </Typography>
                            <Typography component={RouterLink} to="/contact" sx={linkSx}>
                                Contact us
                            </Typography>
                            <Typography
                                component="a"
                                href={DRIVER_PORTAL_URL}
                                target="_blank"
                                rel="noopener noreferrer"
                                sx={linkSx}
                            >
                                Driver portal
                            </Typography>
                        </Stack>
                    </Grid>

                    <Grid item xs={6} sm={4} md={3}>
                        <Typography sx={headingSx}>Contact</Typography>
                        <Stack spacing={1.25}>
                            <Typography component="a" href={PHONE_HREF} sx={linkSx}>
                                {PHONE_DISPLAY}
                            </Typography>
                            <Typography
                                component="a"
                                href={EMAIL_HREF}
                                sx={{ ...linkSx, wordBreak: "break-word" }}
                            >
                                {EMAIL}
                            </Typography>
                            <Typography
                                variant="body2"
                                sx={{
                                    color: "rgba(255, 255, 255, 0.68)",
                                    lineHeight: 1.7,
                                    pt: 0.5,
                                }}
                            >
                                {OFFICE_ADDRESS_SHORT}
                            </Typography>
                        </Stack>
                    </Grid>

                    <Grid item xs={12} sm={4} md={2}>
                        <Typography sx={headingSx}>Follow</Typography>
                        <IconButton
                            component="a"
                            href={FACEBOOK_URL}
                            target="_blank"
                            rel="noopener noreferrer"
                            aria-label="Stargate Rentals on Facebook"
                            sx={{
                                color: "#fff",
                                border: "1px solid rgba(255, 255, 255, 0.22)",
                                borderRadius: 2,
                                "&:hover": {
                                    color: "#00A3FF",
                                    borderColor: "#00A3FF",
                                    background: "rgba(0, 163, 255, 0.08)",
                                },
                            }}
                        >
                            <FacebookOutlined />
                        </IconButton>
                    </Grid>
                </Grid>

                <Divider sx={{ borderColor: "rgba(255, 255, 255, 0.12)", mt: { xs: 5, md: 6 } }} />

                <Stack
                    direction={{ xs: "column", sm: "row" }}
                    spacing={1.5}
                    alignItems={{ xs: "flex-start", sm: "center" }}
                    justifyContent="space-between"
                    sx={{ py: 2.5 }}
                >
                    <Typography
                        variant="body2"
                        sx={{ color: "rgba(255, 255, 255, 0.55)", fontSize: "0.8125rem" }}
                    >
                        © {year} Clerk Solutions Limited. All rights reserved.
                    </Typography>
                    <Typography
                        component={RouterLink}
                        to="/privacyPolicy"
                        sx={{
                            ...linkSx,
                            fontSize: "0.8125rem",
                            color: "rgba(255, 255, 255, 0.55)",
                        }}
                    >
                        Privacy Policy
                    </Typography>
                </Stack>
            </Container>
        </Box>
    )
}

export default Footer
